import { render } from "./aio-login-toggle.vue?vue&type=template&id=79422879&scoped=true"
import script from "./aio-login-toggle.vue?vue&type=script&lang=js"
export * from "./aio-login-toggle.vue?vue&type=script&lang=js"

import "./aio-login-toggle.vue?vue&type=style&index=0&id=79422879&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79422879"]])

export default __exports__